<template>
  <div>
    <upload
      :accept="accept"
      :format="format"
      action="/"
      :multiple="false"
      :show-upload-list="false"
      v-bind="$listeners"
      :before-upload="before_upload"
      type="drag"
      class="dnd-uploader"
    >
      <div
        v-if="file_preview.name"
        class="dnd-uploader__drop-zone flex flex--center flex--row-center"
      >
        <icon type="md-document" size="52" class="drop-zone__icon mr-2" />
        <div class="text-cut file-name">{{ file_preview.name }}</div>
      </div>

      <div v-else class="dnd-uploader__drop-zone">
        <div v-if="is_loading" class="drop-zone__loader">
          <spin size="large" />
        </div>

        <icon v-if="!is_loading" type="ios-cloud-upload" size="52" class="drop-zone__icon" />

        <p class="text-center text-muted">{{ $t('shared.component.file_upload.drag') }}</p>
      </div>
    </upload>
    <p class="small text-muted mb-0 mt-4">
      {{ $t('shared.component.file_upload.format') }}: {{ format_user }}.
    </p>
    <p class="small text-muted mb-0">
      {{ $t('shared.component.file_upload.weight_mb', { weight: 1 }) }}
    </p>
    <p class="small text-muted mb-0">
      {{ $t('shared.component.file_upload.row_1000') }}
    </p>
    <p class="small text-muted mb-0">
      {{ $t('shared.component.file_upload.download_example') }}
      <span
        :class="is_template_loading ? 'link link--disabled' : 'link'"
        @click="download_templates"
      >
        {{ $t('shared.component.file_upload.template') }}
      </span>
    </p>
  </div>
</template>

<script>
  import { TaskService } from '@autocaller_v2/services/TaskService';
  import { downloadCSV } from '@/plugins/files';

  const formats = ['csv', 'xls', 'xlsx'];

  export default {
    props: {
      is_loading: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      file_preview: {},
      accept: formats.map((i) => `.${i}`).join(','),
      format_user: formats.map((i) => `.${i}`).join(', '),
      format: formats,
      is_template_loading: false
    }),

    methods: {
      download_templates() {
        this.is_template_loading = true;
        TaskService.downloadTemplates()
          .then((response) => {
            downloadCSV(response, 'filename="template');
          })
          .catch((error) => this.$noty.server_error(error))
          .finally(() => (this.is_template_loading = false));
      },
      before_upload(file) {
        const max_file_size = 1 * 1000 * 1000;
        const valid_file = formats.filter((format) => file.name?.includes(`.${format}`))?.length > 0;

        if (file.size < max_file_size && valid_file) {
          this.file_preview = file;
          this.$emit('before_upload', file);
        } else if (file.size > max_file_size) {
          const warning_msg = this.$t('core.document.error.max_size', { filename: file.name });
          this.$noty.warning(warning_msg);
        } else if (!valid_file) {
          this.$noty.warning(this.$t('shared.component.file_upload.invalid_format'));
        }
        return false;
      }
    }
  };
</script>

<style lang="scss">
  .dnd-uploader {
    &__drop-zone {
      padding: 20px 0;

      .text-center {
        margin: 0 5px;
      }
    }
  }

  .drop-zone__loader {
    height: 52px;
    width: 52px;
    margin: 0 auto;
  }

  .drop-zone__icon {
    color: $primary;
  }
</style>
